import _ from 'lodash';
import { COUNTRIES } from './countries.constants';
const countriesCache = new Map();
export const getConfigByCountry = (iso2 = 'us') => {
    if (countriesCache.has(iso2)) {
        return countriesCache.get(iso2);
    }
    let result = _.find(COUNTRIES, (x) => x.iso2 === _.toLower(iso2));
    if (!result) {
        result = _.find(COUNTRIES, (x) => x.iso2 === 'us');
    }
    countriesCache.set(iso2, result);
    return result;
};
